import { useTranslation } from "react-i18next";
import SearchPlusIcon from "../../../layout/left_menu_icons/searchPlus.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useGeneralContext } from "../../General/Context";

export default function Heading() {
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();
  const history = useHistory();
  return (
    <header className="page-header">
      <div className="header-title">
        <div className="title">
          <img src={SearchPlusIcon} alt="ni-icon" />
          <h1 style={{ marginTop: "10px" }}>{t("Advanced Search")}</h1>
        </div>
        <div className="subtitle">{t("Recruitment / Advance Search")}</div>
      </div>

      <div className="text-end me-5">
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="flexSwitchCheckDefault"
            checked={true}
            onClick={() => {
              history.push("/interview/advanceSearch");
            }}
          />
          <label class="form-check-label" for="flexSwitchCheckDefault">
            {t("classic")}
          </label>
        </div>
      </div>
    </header>
  );
}
